// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1jDc1","alert":"SettungsInbox_alert__2iXil"};